// extracted by mini-css-extract-plugin
export default {"layout":"Pill_layout__AThQQ","badge":"Pill_badge__yDV25","label":"Pill_label__sbHQH","invisiblelabel":"Pill_invisiblelabel__WgV3T"};